import { render } from "./InicioPagos.vue?vue&type=template&id=5b70f98c&scoped=true"
import script from "./InicioPagos.vue?vue&type=script&lang=js"
export * from "./InicioPagos.vue?vue&type=script&lang=js"

import "./InicioPagos.vue?vue&type=style&index=0&id=5b70f98c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70f98c"]])

export default __exports__